export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_18.9314af04.jpg";